import React, { RefObject } from 'react'
import {
    StyledModal,
    StyledModalMain,
    StyledSubscribeButton,
} from './LatestEdition.styled'
import { TheWestSection } from '@news-mono/common'

export interface SubscriberModalProps {
    showModal: boolean
    setShowModal: (showModal: boolean) => void
    handleClickOutsideModal: (e: React.MouseEvent<HTMLDivElement>) => void
    innerModalRef: React.MutableRefObject<null>
    crossIconRef: RefObject<HTMLButtonElement>
    section: TheWestSection
    isLoggedIn: boolean
    onLoginClick: () => void
}

export const SubscriberModal: React.FC<SubscriberModalProps> = ({
    showModal,
    setShowModal,
    handleClickOutsideModal,
    innerModalRef,
    crossIconRef,
    section,
    isLoggedIn,
    onLoginClick,
}) => {
    const defaultPrice = '$8 per week'

    return (
        <StyledModal showModal={showModal} onClick={handleClickOutsideModal}>
            <StyledModalMain className="modal-main" ref={innerModalRef}>
                <StyledSubscribeButton
                    onClick={() => {
                        setShowModal(false)
                        window.open('/editions/subscribe')
                    }}
                >
                    Subscribe from{' '}
                    <text style={{ textDecoration: 'underline' }}>
                        {defaultPrice}
                    </text>
                </StyledSubscribeButton>
            </StyledModalMain>
        </StyledModal>
    )
}
